/**
 * @version GENERATOR_VERSION::20200408
 * @DateTime 2020-04-20T20:38:25.772
 * @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
 **/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'storagemanage-DroomPropertyDelivery-'

export default {
    path: '/storagemanage/droompropertydelivery',
    name: 'storagemanage-DroomPropertyDelivery',
    redirect: {
        name: '${pre}-index'
    },

    meta: {
        ...meta,
    },

    component: BasicLayout,
    children: [{
            path: 'index',
            name: '${pre}DroomPropertyDelivery-index',

            meta: {
                ...meta,
                title: '物业交付'
            },

            component: () => import('@/pages/storagemanage/droompropertydelivery/index'),
        },
        {
            path: 'detail-edit/:id',
            name: '${pre}DroomPropertyDelivery-detail-edit',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '物业交付编辑',
                cache: true,
            },

            component: () => import('@/pages/storagemanage/droompropertydelivery/detail-edit'),
        },
        {
            path: 'detail-edit',
            name: '${pre}DroomPropertyDeliverydetail-create',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '物业交付编辑'
            },

            component: () => import('@/pages/storagemanage/droompropertydelivery/detail-edit'),
        },
        {
            path: 'detail-view/:id',
            name: '${pre}DroomPropertyDeliveryView',
            auth: [
                'hidden'
            ],

            meta: {
                ...meta,
                title: '物业交付详情查看'
            },

            component: () => import('@/pages/storagemanage/droompropertydelivery/detail-view'),
        },
    ]
};
